import styled from 'styled-components';


export const PageContainer = styled.main`
  width: 100%;
`;


export const HeroSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40vh; 
  width: 100%;
  position: relative; 

  
  background-image: url('/Fundo-Quem-Somos-1.png'); 
  background-attachment: fixed; 
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

 
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
   
  }
`;


export const HeroTitle = styled.h1`
  font-family: 'Raleway', sans-serif;
  color: #ffffff; 
  font-size: 52px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: right;
  padding-right: 10%;
`;


export const ContentSection = styled.section`
  background-color: #f9f9f9; 
  padding: 40px 40px; 

  p {
    color: #000000; 
    font-size: 20px;
    line-height: 1.5; 
    text-align: center; 
    max-width: 1100px; 
    margin: 0 auto 20px auto;

    &:last-child {
      margin-bottom: 0; 
    }
  }
`;

export const ParallaxDivider = styled.section`
  height: 30vh; 
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;


 
  background-image: url('/Fundo-Quem-Somos-1.png');
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

 
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;


export const TitleContainer = styled.div`
  background-color: #02391E; 
  padding: 5px 10px;
  border-radius: 15px; 
  z-index: 2; 
  box-shadow: 0px 4px 15px rgba(0,0,0,0.2);
  text-align: center;
  
  ${(props) => props.align === 'right' && `
    margin-left: auto;   
    margin-right: 10%; 
  `}


  ${(props) => props.align === 'left' && `
    margin-right: auto;  
    margin-left: 10%;  
  `}
`;


export const Title = styled.h2`
  font-family: 'Raleway', sans-serif;
  color: #ffffff;
  font-size: 32px; 
  font-weight: 300; 
  text-transform: uppercase;
  margin: 0; 
  padding: 0;
`;


export const ValuesSection = styled.section`
  padding: 80px 20px;
  background-color: #ffffff; 
`;




export const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  max-width: 1200px;
  margin: 0 auto;
  gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr); 
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr; 
  }
`;


export const ValueCard = styled.div`
  background-color: #F1D591;
  border-radius: 30px; 
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px); 
    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  }
`;


export const ValueTitle = styled.h3`
  color: #02391E;
  text-transform: uppercase; 
  font-size: 30px;
  font-weight: 900;
  margin-top: 0;
  margin-bottom: 15px;
`;


export const ValueText = styled.p`
  color: #000000; 
  font-size: 20px;
  line-height: 1.5;
  margin: 0;
`;

export const PartnersSection = styled.section`
  position: relative;
  padding: 80px 20px;
  background-image: url('/Fundo-Quem-Somos-2.png');
  background-size: cover;
  background-position: center;

  &::before {
    content: ''; 
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  
    background-color: rgba(225, 207, 207, 0.55);
    z-index: 1; 
  }

`;

export const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr; 
  align-items: center;
  gap: 50px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  

 @media (max-width: 768px) {
    grid-template-columns: 1fr; 
    gap: 40px; 
  }

    
`;

export const LeftColumn = styled.div`

  flex-direction: column;
  margin-left: 100px;
  margin-bottom: 50px; 
  
  @media (max-width: 768px) {
    align-items: center; 
  }
  

h2 { 
margin-bottom: 5px; 
}

  img {
    width: 350px;
    margin-bottom: 0;
  }

`;

export const PartnerTitle = styled.h2`
  font-family:'Raleway', sans-serif; 
  color:rgb(255, 255, 255); 
  font-size: 30px;
  font-weight: 300;
  text-transform: uppercase;
  line-height: 1.2;
  margin-bottom: 0; 


  }
`;

export const RightColumn = styled.div`
 width: 800px;

   @media (max-width: 768px) { 
    width: 450px;
   }

 
`;

export const FeatureList = styled.ul`
  list-style-type: none; 
  padding: 0;
  margin: 0;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start; 
  margin-bottom: 5px; 
  
  img {
    width: 24px; 
    margin-right: 15px; 
    margin-top: 3px; 
  }

  span {
    color:rgb(0, 0, 0);
    font-size: 20px;
    line-height: 1.6;
    font-weight: 500;
    
  }

  &:last-child {
    margin-bottom: 0;
  }

 
  @media (max-width: 768px) {
   
    span {
     margin-bottom: 20px; 
      font-size: 16px;
      flex: 1;
      word-break: break-word;
    }
`;